import { author } from '../data/profile';
import './Footer.css';

const SITE_LAUNCH_YEAR = 2026;

interface FooterProps {
  time: string;
}

function formatCopyrightYear(now: Date = new Date()): string {
  const current = now.getFullYear();
  return current > SITE_LAUNCH_YEAR ? `${SITE_LAUNCH_YEAR}—${current}` : String(SITE_LAUNCH_YEAR);
}

export function Footer({ time }: FooterProps) {
  return (
    <footer className="footer">
      <div className="footer-line">
        <span>© {formatCopyrightYear()} {author.name}</span>
        <span className="mono">{time} · {author.city}</span>
      </div>
    </footer>
  );
}
